export default "__VITE_ASSET__Cb2gHxwK__"